import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import getConfig from 'next/config';
import classNames from 'classnames';
import jsCookie from 'js-cookie';
import GoogleOneTapLogin from 'react-google-one-tap-login';

import SimpleNav from '../SimpleNav';
import { Footer } from '@lifepal/lifepal-design-system';
import { HTTPClient } from '../../lib/api';
import { log_error } from '../../utils/logger';
import useWebView from '../../utils/hooks/useWebView';
import useAuthenticated from '../../utils/hooks/useAuthenticated';
import Navigation from '../Navigation/Navigation';

import styles from './Layout.module.scss';

const { GOOGLE_CLIENT_ID } = getConfig().serverRuntimeConfig;

export function Layout({ children }) {
  const isAuthenticated = useAuthenticated();
  const isWebView = useWebView();
  const router = useRouter();

  const [showOneTap, setShowOneTap] = useState(false); //Show google signin plugin
  const [fullName, setFullName] = useState(''); //for thank you message
  const [showThank, setShowThank] = useState(false);

  useEffect(() => {
    const clickedOneTap = jsCookie.get('OneTapClick'); //Check if user has signed in before current session
    if (!clickedOneTap) {
      setShowOneTap(true);
    }
  });

  const sendToSendgrid = async (data) => {
    const payload = [
      {
        first_name: data.given_name,
        last_name: data.family_name,
        email: data.email,
        source: 'Google Auth Plugin',
      },
    ];
    const accountPayload = {
      method: 'POST',
      body: JSON.stringify(payload),
    };

    const accountResponse = await HTTPClient(
      `${router.basePath}/api/external/sendgrid/`,
      accountPayload
    );

    const accountListPayload = {
      method: 'POST',
      body: JSON.stringify([{ id: accountResponse && accountResponse.persisted_recipients[0] }]),
    };

    return await HTTPClient(`${router.basePath}/api/external/sendgrid-list/`, accountListPayload);
  };

  const ThankYouMessage = () => {
    return (
      <div className={styles.gsignin__thank}>
        <img
          src="/media/static/images/mediaLeadSubmit.svg"
          alt="Google Sign in thank you"
          width={120}
          height={120}
        />
        <div className={styles.gsignin__thank__title}>Hi, {fullName}</div>
        <div className={styles.gsignin__thank__subtitle}>
          Terima kasih telah mendaftar. Kami akan mengirimkan Anda konten serupa dan promo terbaru
          melalui email Anda.
        </div>
        <button className={styles.gsignin__thank__closeBtn} onClick={() => setShowThank(false)}>
          Ok
        </button>
      </div>
    );
  };

  const setNavigation = () => {
    if (isWebView) return '';
    else if (router.query.slug === 'tentang') return <SimpleNav />
    else return <Navigation />
  }

  return (
    <div className={styles.main}>
      {!isAuthenticated && showOneTap && !showThank && (
        <GoogleOneTapLogin
          onError={(error) => {
            alert('Terjadi kesalahan pada sistem kami, silakan coba lagi');
            log_error('Google One Tap', 'error', error);
          }}
          onSuccess={async (response) => {
            await sendToSendgrid(response);
            setShowOneTap(false);
            jsCookie.set('OneTapClick', true);
            setFullName(response.name);
            setShowThank(true);
          }}
          googleAccountConfigs={{
            client_id: GOOGLE_CLIENT_ID,
          }}
        />
      )}
      {showThank && <ThankYouMessage />}
      <header className={styles.header__wrapper}>
        {setNavigation()}
      </header>
      <div className={classNames('container', styles.main__content)}>{children}</div>

      {!isAuthenticated && !isWebView && (
        <div className="container">
          <Footer
            footerImage="/media/static/images/payment-method-and-installment.png"
            showRegularFooter={true}
          />
        </div>
      )}
    </div>
  );
}
